import React from 'react';
import BaseModal from 'src/common/components/Modal';

const DeleteConsultModal = ({ open, setClose, onDelete }) => {
	return (
		<BaseModal
			open={open}
			mainText="Eliminar Usuario"
			confirmLabel="Si, eliminar"
			onConfirm={onDelete}
			onClose={() => setClose(false)}
			onCancel={() => setClose(false)}
		>
			<h5>¿Seguro que desea eliminar este usuario?</h5>
		</BaseModal>
	);
};

export default DeleteConsultModal;
